module.exports = __webpack_public_path__ + "img/step-eight-icon.5cb013d8.jpg";